<script>
    import { t } from '../core/i18n/language-store';
    import {get} from "svelte/store";
    import {menuStore, publishConfigStore, tenantKeyStore} from "../core/app-store.js";
    import {
        addToCartHandler,
        removeFromCartHandler
    } from "../cart/cart-store.js";
    import RecordCard from "./RecordCard.svelte";

    const publishConfig = get(publishConfigStore);
    const menu = get(menuStore);
    const tenantKey = get(tenantKeyStore);

    export let favorites = [];

</script>

<style>
    .favorite-records {
        display: flex;
        gap: 1rem;
        overflow-y: auto;
    }
    .favorite-record-container {
        min-width: 150px;
    }
</style>

{#if (favorites && favorites.length > 0) }

    <div class="flex-column gap-05">

        <h2>{$t('blocks.favorites.title')}</h2>

        <div class="favorite-records">
            {#each favorites as record}
                <div class="favorite-record-container">
                    <RecordCard record={record}
                                publishConfig={publishConfig}
                                tenantKey={tenantKey}
                                on:removeFromCart={(record) => removeFromCartHandler(record.detail)}
                                on:addToCart={(record) => addToCartHandler(record.detail)}
                    ></RecordCard>
                </div>
            {/each}
        </div>

    </div>

{/if}
